import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format price without trailing zeros: 10.00 → 10, 10.50 → 10.5 */
export function formatPrice(price: number): string {
  if (Number.isInteger(price)) return price.toString();
  return parseFloat(price.toFixed(2)).toString();
}
